import { ButtonBase, Typography as T } from "@mui/material";

import { reduceIconPath } from "helpers/functions";
import { palette } from "theme/palette";

type Props = {
  onClick: () => void;
  nextButtonText?: string;
  disabled?: boolean;
};

export const NextButton = ({
  onClick,
  nextButtonText = "Next",
  disabled = false,
}: Props) => {
  return (
    <ButtonBase
      sx={{
        borderWidth: "2px",
        borderStyle: "solid",
        borderColor: disabled ? palette.grey : palette.accent,
        background: disabled ? palette.white : palette.accent,
        width: nextButtonText === "Next" ? [80, 126, 206] : [150, 196, 240],
        height: [46, 50, 54],
        borderRadius: "8px",
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <T
        variant="h5sb"
        sx={{
          color: disabled ? palette.black : palette.white,
          marginRight: 1,
          fontSize: [16, 18],
        }}
      >
        {nextButtonText}
      </T>
      {nextButtonText === "Next" ? (
        <img
          src={reduceIconPath("next-button-icon.svg")}
          alt={"next button icon"}
        />
      ) : (
        ""
      )}
    </ButtonBase>
  );
};
